import makeStyles from "@mui/styles/makeStyles";

const Style = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    backgroundColor: "#eaeaea"
  },
  content: {
    justifyContent: "center",
    alignContent: "center",
    display: "flex",
    flex: 1,
    maxWidth: 472,
  },
  windowBackground: {
    padding: 20,
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  logoBackground: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px 0px 20px",
    position: "relative",
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
  },
  logoImg: {
    height: 70,
    marginBottom: 40
  },
  contentContainer: {
    padding: 20,
  },
  buttonFooter: {
    fontWeight: "bold",
    width: "100%",
    fontFamily: "Arial",
  },
  title: {
    fontFamily: "Geomanist Medium",
    fontSize: 16,
    fontWeight: 500,
    color: "red"
  },
  atention: {
    fontFamily: "Geomanist Book",
    fontSize: 16,
  },
  message: {
    fontFamily: "Geomanist Book",
    fontSize: 16,
  },
}));

export default Style;
